<template>
    <div class="page__alerts block" v-cloak v-if="showMessage" style="margin-bottom: 0">
        <div class="alert alert--info">
            <span>
                Уважаемый потребитель!<br />
                Информируем Вас о том, что с 01.06.2021г. возобновлено очное обслуживание клиентов. За получением расчетно-платежных документов просим Вас обращаться в Центр по обслуживанию клиентов по адресу г. Кемерово пр-т Ленина, 90/3, каб. 217, 2 этаж. <br />График работы: пн. – чт. с 08-00 до 17-00, пт. с 08-00 до 16-00, обед с 12-00 до 12-48, за дополнительной информацией обращаться по тел. 45-35-59.
            </span>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            accounts: {
                type: Array
            }
        },

        data() {
            return {
                divisions: [
                    { databaseId: "omnis_kuz", divisionId: "32", divisionName: "АО \"Кемеровская генерация\"" },
                    { databaseId: "omnis_kuz", divisionId: "31", divisionName: "АО \"Ново-Кемеровская ТЭЦ\"" },
                    { databaseId: "omnis_kuz", divisionId: "116", divisionName: "ООО \"НТСК\"" }
                ]
            };
        },

        computed: {

            /**
             * Показывать ли сообщение
             * */
            showMessage: function () {

                return false;
                //var divisions = this.divisions;
                //var accounts = this.accounts;

                //// Если есть счет из списка подразделений
                //return accounts && accounts.some(function (account) {
                //    return divisions.some(function (division) {
                //        return (account.databaseId.toLowerCase() === division.databaseId.toLowerCase()
                //            || account.databaseId.toLowerCase() === division.databaseId.toLowerCase() + "_lkk") &&
                //            account.divisionId.toString() === division.divisionId.toString();
                //    });
                //});
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// Scripts/Components/Accounts/OfflineServiceAvailableAd.vue